<template>
  <div class="menu">
    <span class="menu_title">
      <a href="https://edgeryders.eu" class="logo"> </a>
      <h2 @click="openProject(project.id)">{{project.id.replace('-', ' ')}}</h2>
    </span>
    <scrollactive :offset="80" class="links">
      <a v-for="(item, index) in getItems()" class="scrollactive-item" :key="index" :href="item.url">{{item.text}}</a>
    </scrollactive>

    <div class="mobile_menu_icon" @click="toggleMenu" :class="{'active': mobileMenu}">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>

    <MobileMenu :open="mobileMenu" :header="header" :links="getItems()" @toggle="toggleMenu" />

  </div>
</template>

<script>
// import RadialProgressBar from "vue-radial-progress";
import moment from "moment";
import { bus } from "@/main";
import MobileMenu from "@/components/elements/MobileMenu";

export default {
  name: "App",
  data() {
    return {
      mobileMenu: false,
      project: {
        id: null
      }
    };
  },
  components: {
    MobileMenu
  },
  props: ["account", "header", "edit", "menu", "views"],
  methods: {
    toggleMenu(){
      this.mobileMenu = !this.mobileMenu;
    },
    openProject(id) {
      bus.$emit("loadProject", id);
    },
    getAvatar(data) {
      return "https://edgeryders.eu" + data.replace("{size}", 200);
    },
    getName(data) {
      return data.name || "@" + data.username;
    },
    getProfile(data) {
      return "https://edgeryders.eu/u/" + data.username;
    },
    getItems() {
      return this.views.filter(x => x.level == 'H2').map(x => this.createLink(x));
    },
    createLink(item) {
      var obj = {
        text: item.content,
        url: this.getAnchor(item.content)
      }
      return obj
    },
    getAnchor(text) {
      return '#' + text.toLowerCase().replace(/ /g, '-')
    }
  },
  mounted() {},
  filters: {
    formatDate: function(value) {
      return moment(String(value)).format("dddd, MMMM Do YYYY");
    },
    formatTime: function(value) {
      return moment(String(value)).format("hh:mm A");
    },
  },
  created() {
    this.project.id = window.location.pathname.split("/")[2];
  },
};
</script>
<style lang="scss">
.menu {
  position: fixed;
  z-index: 9999;
  top: 0px;
  width: 100%;
  height: 60px;
  background: rgba(0, 0, 0, 0);
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: white;
  transition: all 0.4s ease;
  color: rgba(0, 0, 0, 0.8);
  transition: background 0.35s ease;
  .progress {
  }
  &.active {
    @apply border-b;
    top: 0px;
    color: black !important;
    background: white;
    backdrop-filter: blur(1px);
    .links {
      height: 100%;
      a {
      border-color: #e5e7eb;
      transition: background .4s ease;
      &:hover {
       background: #efefef;
      }
      &.is-active {
            background: #fafafa;
     border-left: 1px solid #e5e7eb !important;

    }
     }
    }
  }
  .menu_title {
    display: flex;
    @apply flex items-center;
    .logo {
      background-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 500 500' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0 250a250 250 0 11500 0 250 250 0 01-500 0zm97-103v106h42v-16h-26v-31h19v-16h-19v-27h26v-16zm80 91c6 0 8-4 8-11v-52c0-8-4-12-13-12h-4v75zm-25-91h23c19 0 27 10 27 29v48c0 20-8 29-26 29h-24zm63 25c0-17 9-27 25-27s24 9 24 27v10h-16v-11c0-8-3-11-8-11-6 0-9 3-9 11v59c0 7 3 11 9 11 5 0 8-4 8-11v-17h-10v-13h26v53h-8l-3-7c-4 7-9 10-16 10-14 0-22-11-22-30zm64-25h43v16h-26v27h18v16h-18v31h26v16h-43zM112 381H95V275h24c18 0 26 8 26 30 0 13-3 21-10 26l12 50h-17l-10-45h-8zm0-60v-31h6c8 0 10 3 10 15 0 11-2 16-10 16zm53-46l10 42h1l10-42h17l-19 62v44h-16v-42l-20-64zm69 90c6 0 9-4 9-11v-51c0-9-4-13-13-13h-4v75zm-24-90h23c18 0 27 9 27 29v47c0 20-8 30-26 30h-24zm136 46v-31h6c8 0 10 3 10 15 0 11-2 16-10 16zm-72-46h43v15h-26v28h19v15h-19v32h26v16h-43zm72 106h-16V275h24c17 0 25 8 25 30 0 13-3 21-10 26l12 50h-17l-10-45h-8zm57-30c1 11 4 16 11 16 6 0 10-4 10-10 0-9-6-14-15-23-12-12-20-21-20-35 0-15 11-26 25-26s24 10 25 26l-16 2c-1-9-3-13-9-13-5 0-9 4-9 10 0 9 7 16 17 25 11 11 18 19 18 34s-11 26-26 26-26-11-27-29zm-65-172v-42h-42a42 42 0 1142 42z' fill='rgba(0,0,0,0.8)' fill-rule='evenodd'/%3E%3C/svg%3E");
      background-size: cover;
      height: 38px;
      width: 38px;
      @apply mx-4 mr-3;
    }
    h2 {
      @apply text-xl font-bold;
      text-transform: capitalize;
      &:hover {
      cursor: pointer;
      text-decoration: underline;
    }
    }
  }
  .account {
    display: flex;
    @apply flex items-center mr-4;
    img {
      @apply mr-2;
      border: 2px solid #efefef;
      width: 35px;
      height: 35px;
      border-radius: 50px;
    }
    a {
      @apply font-bold text-base;
      &:hover {
        color: orangered;
      }
    }
  }
  &.active {
    .menu_title {
      .logo {
        background-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 500 500' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0 250a250 250 0 11500 0 250 250 0 01-500 0zm97-103v106h42v-16h-26v-31h19v-16h-19v-27h26v-16zm80 91c6 0 8-4 8-11v-52c0-8-4-12-13-12h-4v75zm-25-91h23c19 0 27 10 27 29v48c0 20-8 29-26 29h-24zm63 25c0-17 9-27 25-27s24 9 24 27v10h-16v-11c0-8-3-11-8-11-6 0-9 3-9 11v59c0 7 3 11 9 11 5 0 8-4 8-11v-17h-10v-13h26v53h-8l-3-7c-4 7-9 10-16 10-14 0-22-11-22-30zm64-25h43v16h-26v27h18v16h-18v31h26v16h-43zM112 381H95V275h24c18 0 26 8 26 30 0 13-3 21-10 26l12 50h-17l-10-45h-8zm0-60v-31h6c8 0 10 3 10 15 0 11-2 16-10 16zm53-46l10 42h1l10-42h17l-19 62v44h-16v-42l-20-64zm69 90c6 0 9-4 9-11v-51c0-9-4-13-13-13h-4v75zm-24-90h23c18 0 27 9 27 29v47c0 20-8 30-26 30h-24zm136 46v-31h6c8 0 10 3 10 15 0 11-2 16-10 16zm-72-46h43v15h-26v28h19v15h-19v32h26v16h-43zm72 106h-16V275h24c17 0 25 8 25 30 0 13-3 21-10 26l12 50h-17l-10-45h-8zm57-30c1 11 4 16 11 16 6 0 10-4 10-10 0-9-6-14-15-23-12-12-20-21-20-35 0-15 11-26 25-26s24 10 25 26l-16 2c-1-9-3-13-9-13-5 0-9 4-9 10 0 9 7 16 17 25 11 11 18 19 18 34s-11 26-26 26-26-11-27-29zm-65-172v-42h-42a42 42 0 1142 42z' fill='black' fill-rule='evenodd'/%3E%3C/svg%3E");
      }
    }
  }
  &.has_image {
    .menu {
      border: none;
      &.active {
        border-bottom: 0.5px solid #efefef;
      }
    }
  }
}

.links {
  @apply flex;
  height: 60%;
  transition: height .2s ease;
  a {
    @apply font-bold flex border-l items-center px-5;
    border-color: rgba(0,0,0,0.1);
    &:first-child {
    @apply border-none;
  }

  
  }
}

.progress_container {
  display: flex;
  position: absolute;
  left: 50%;
  margin: 0 auto;
  @apply items-center;
  transition: transform 1.3s ease;
  &.active {
    transform: translateX(-50px);
  }
  .social {
    @apply ml-2;
    height: 60px;
    justify-self: stretch;
    overflow: hidden;
    display: flex;
    position: absolute;
    right: -140px;
    @apply items-center;
    span {
      width: 35px;
      border-radius: 100px;
      height: 35px;
      background: black;
      display: inline-block;
      opacity: 0;
      @apply mr-2;
      transform: translateY(30px);
      transition: all 0.3s ease;
      &.twitter {
        background: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' height='244.2' width='300'%3E%3Cpath d='M95 243A173 173 0 00269 61c11-8 22-19 30-31-11 5-23 8-35 9 13-7 22-19 27-34-12 7-25 13-39 15a61 61 0 00-104 56C97 74 52 49 22 12a61 61 0 0019 82c-10 0-20-3-28-8v1c0 30 21 54 49 60a61 61 0 01-28 1c8 24 31 42 58 42a123 123 0 01-91 26c27 17 59 27 94 27' fill='%23fff'/%3E%3C/svg%3E")
          #1da1f2 no-repeat;
        background-size: 50% !important;
        background-position: center 55% !important;
      }
      &.facebook {
        background: url("data:image/svg+xml,%3Csvg aria-hidden='true' data-prefix='fab' data-icon='facebook-f' class='svg-inline--fa fa-facebook-f fa-w-10' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 320 512'%3E%3Cpath fill='%23fff' d='M279 288l14-93h-89v-60c0-25 13-50 53-50h40V6s-37-6-72-6c-73 0-121 44-121 125v70H23v93h81v224h100V288z'/%3E%3C/svg%3E")
          #4767aa no-repeat;
        background-size: 29% !important;
        background-position: 48% 52% !important;
      }
      &.email {
        background: url("data:image/svg+xml,%3Csvg aria-hidden='true' data-prefix='fas' data-icon='at' class='svg-inline--fa fa-at fa-w-16' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'%3E%3Cpath fill='%23fff' d='M256 8a248 248 0 10135 456c12-8 15-25 6-36l-10-12c-8-9-21-12-32-5A184 184 0 0172 256c0-101 83-184 184-184 100 0 184 58 184 160 0 39-21 80-58 84-18-1-17-13-14-30l24-121c3-15-9-29-24-29h-45a14 14 0 00-13 12c-15-18-41-22-60-22-75 0-138 63-138 152 0 65 37 106 96 106 27 0 57-16 75-39 10 34 41 34 71 34 109 0 150-71 150-147C504 96 394 8 256 8zm-22 304c-22 0-36-15-36-40 0-45 31-73 59-73 22 0 35 15 35 41 0 45-33 72-58 72z'/%3E%3C/svg%3E")
          no-repeat #000;
        background-size: 50% !important;
        background-position: center 55% !important;
      }
      &:nth-child(1) {
        transition-delay: 0.5s !important;
      }
      &:nth-child(2) {
        transition-delay: 0.65s !important;
      }
      &:nth-child(3) {
        transition-delay: 0.75s !important;
      }
    }
    &.active {
      span {
        opacity: 1;
        transform: translateY(0px);
        transition: all 0.3s ease;
      }
    }
  }
}
.progress {
  position: relative;
  .cbx {
    left: 4px;
    top: 4px;
    span {
      width: 32px;
      height: 32px;
      margin-left: 0px;
      display: flex;
      align-items: center;
      justify-content: center;
      svg {
        position: relative;
        top: 0;

        left: 0;
      }
    }
  }
}

$height: 50px;
$trs-time: 0.3s;

.mobile_menu_icon {
  width: 25px;
  height: 30px;
  margin-top: 10px;
  margin-right: 20px;
  transform: rotate(0deg);
  transition: .5s ease-in-out;
  cursor: pointer;
  display: none;
  z-index: 999999;
  span {
    display: block;
    position: absolute;
    height: 2px;
    width: 100%;
    background: #000;
    border-radius: 9px;
    opacity: 1;
    left: 0;
    transform: rotate(0deg);
    transition: .25s ease-in-out;
    &:nth-child(1) {
      top: 0px;
    }
    &:nth-child(2) {
      top: 9px;
    }
    &:nth-child(3) {
      top: 9px;
    }
    &:nth-child(4) {
      top: 18px;
    }
  }
  &.active {
    span {
      &:nth-child(1) {
        top: 9px;
        width: 0%;
        left: 50%;
      }
      &:nth-child(2) {
        transform: rotate(45deg);
      }
      &:nth-child(3) {
        transform: rotate(-45deg);
      }
      &:nth-child(4) {
        top: 9px;
        width: 0%;
        left: 50%;
      }
    }
  }
}

@media only screen and (max-width: 600px) {
  .links {
    display: none !important;
  }
  .mobile_menu_icon {
    display: block !important;
  }
}
</style>
